<template>
  <v-card raised class="mt-3">
    <v-card-title class="blue-grey lighten-4" dark>
      <span class="headline font-weight-regular">{{ viewAtual.nome }}</span>
      <v-btn
        title="Recarregar"
        color="blue-grey"
        dark
        class="mb-2"
        small
        absolute
        fab
        right
        style="top: 10px; right: 60px;"
        @click="recarregarDados()"
      >
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-dialog
        @keydown.esc="paymentTypesDialog = false"
        v-model="paymentTypesDialog"
        max-width="550px"
        class="blue darken-1"
        v-if="loggedUser.papeis.filter(papel => papel.nome === 'ADMIN').length === 0"
      >
        <v-btn
          title="Novo"
          v-if="loggedUser.papeis.filter(papel => papel.nome === 'SOLICITANTE').length > 0"
          color="#ff0d7b"
          dark
          slot="activator"
          class="mb-2"
          small
          absolute
          right
          fab
          style="top: 10px;"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-card class="blue darken-4" style="padding:20px">
          <v-card-title style="padding: 0px">
            <p class="messageSelectPaymentType">Opções para Colaborador</p>
          </v-card-title>
          <v-card-text style="padding: 0px">
            <v-layout row wrap>
              <v-flex xs12 style="text-align:center">
                <v-btn ripple style="font-weight: bold" to="/pedidos/reembolsos">Reembolso</v-btn>
                <v-btn ripple style="font-weight: bold" to="/pedidos/adiantamentos">Adiantamento</v-btn>
                <v-btn ripple style="font-weight: bold" to="/pedidos/prestarcontas">Prestar Contas</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="blue darken-2" style="padding:20px">
          <v-card-title style="padding:0px">
            <p class="messageSelectPaymentType">Opções para Fornecedor</p>
          </v-card-title>
          <v-card-text style="padding:0px">
            <v-layout row wrap>
              <v-flex xs12 style="text-align:center">
                <v-btn
                  ripple
                  style="font-weight: bold"
                  to="/pagamentos/fornecedores"
                >Adiantamento / Pagamento</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-btn
        :title="viewAtual.botao"
        class="mb-2"
        small
        absolute
        fab
        right
        style="top: 10px; right: 105px;"
        v-if="canFilterByPerson && 
            loggedUser.papeis.filter(papel => papel.nome === 'SOLICITANTE').length > 0"
        dark
        color="dark"
        @click="mudaView"
        :disabled="loadingRequests"
        :flat="loadingRequests"
      >
        <v-icon>compare_arrows</v-icon>
        <!--
          <span v-if="!loadingRequests">{{ viewAtual.botao }}</span>
         
        <v-progress-circular v-else indeterminate color="blue"></v-progress-circular>-->
      </v-btn>
    </v-card-title>
    <template>
      <div>
        <v-tabs v-model="tab">
          <v-tab>Fornecedor</v-tab>
          <v-tab-item :transition="false" :reverse-transition="false">
            <v-container fluid>
              <v-layout row wrap justify-center>
                <v-flex md12 xs12 class="ma-0 pa-0">
                  <div class="text-xs-center">
                    <component-filtro-avancado
                      :page="page"
                      :viewAtual="viewAtual"
                      :filtro="filtro"
                      telaAtual="PagamentoFornecedor"
                    ></component-filtro-avancado>
                  </div>
                </v-flex>
              </v-layout>

              <v-card>
                <v-card-title class="blue-grey lighten-2 white--text" style="font-size: 20px;">
                  <v-spacer></v-spacer>
                  <v-btn
                    :disabled="itensSelecionados <= 0 || loadingRequests"
                    v-if="loggedUser.papeis.filter(papel => papel.nome === 'PROCURADOR').length > 0"
                    small
                    @click="aprovarPagamentos()"
                    color="primary"
                  >Aprovar Pagamentos</v-btn>
                </v-card-title>
              </v-card>

              <v-data-table
                :items="pedidos.content"
                :headers="headerRequestsTable"
                item-key="index"
                hide-actions
                :loading="loadingRequests"
                :page.sync="page"
                :pagination.sync="pagination"
              >
                <v-progress-linear slot="progress" color="blue" height="5" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <td
                    class="text-xs-center"
                    v-if="loggedUser.papeis.filter(papel => papel.nome === 'PROCURADOR').length > 0"
                  >
                    <v-checkbox
                      v-model="props.item.selecionado"
                      v-if="props.item.status === 'ENVIADO_PARA_PROCURADOR'"
                      class="checkbox-lista"
                    ></v-checkbox>
                  </td>
                  <td
                    class="text-xs-left"
                  >{{ props.item.fornecedor.razaoSocial || props.item.fornecedor.nome }}</td>
                  <td class="text-xs-center">{{ props.item.empresa}}</td>
                  <td class="text-xs-center">{{ props.item.numeroDoDocumento }}</td>
                  <td class="text-xs-right">{{ formataData(props.item.dataDeRegistro) }}</td>
                  <td class="text-xs-right">{{ formataData(props.item.dataDeVencimento) }}</td>
                  <td
                    class="text-xs-right"
                  >{{ converteParaMoedaReal(props.item.valorTotal, props.item.tipoDeMoeda) }}</td>
                  <td class="text-xs-right"
                  >{{ pagamentoParcelado(props.item) }}</td>
                  <td
                    class="text-xs-center"
                  >{{ formatarTipoDeSolicitacao(props.item.tipoDeSolicitacao) }}</td>
                  <td class="text-xs-center">{{ props.item.usuarioRegistrador.nome }}</td>

                  <td v-html="retornaStatus(props.item.status)" class="text-xs-right"></td>
                  <td class="text-xs-center">
                    <v-tooltip bottom class="paddingTooltip">
                      <v-icon
                        small
                        slot="activator"
                        @click="() => {
                      viewRequest(props.item);
                    }"
                      >visibility</v-icon>
                      <span>Visualizar</span>
                    </v-tooltip>

                    <v-tooltip
                      bottom
                      class="paddingTooltip"
                      v-if="loggedUser.id == props.item.usuarioRegistrador.id
                      && props.item.status.indexOf('REPROVADO') > -1"
                    >
                      <v-icon
                        small
                        slot="activator"
                        @click="dialogExcluirItem = true; idParaExcluir = props.item.id"
                      >delete</v-icon>
                      <span>Deletar solicitação</span>
                    </v-tooltip>
                  </td>
                </template>
                <template slot="no-data" v-if="loadingRequests">
                  <v-layout row wrap justify-center>
                    <v-progress-circular indeterminate color="blue"></v-progress-circular>
                  </v-layout>
                </template>
                <template slot="no-data" v-else-if="pedidos.content.length == 0">
                  <div class="text-xs-center">Não há solicitações cadastradas.</div>
                </template>

                <template slot="headers" slot-scope="props">
                  <tr>
                    <th :colspan="headerRequestsTable.length">
                      <v-layout row wrap justify-center>
                        <v-flex md3 lg3>
                          <v-layout justify-center>
                            <p class="title font-weight-bold mt-3" style="color: #005ca3">
                              Total Bruto:
                              <span
                                class="soma-valores"
                              >{{converteParaMoedaReal(totalBruto)}}</span>
                            </p>
                          </v-layout>
                        </v-flex>
                        <v-flex md3 lg3>
                          <v-layout justify-center>
                            <p class="title font-weight-bold mt-3" style="color: #005ca3">
                              Total Liquido:
                              <span
                                class="soma-valores"
                              >{{converteParaMoedaReal(totalLiquido)}}</span>
                            </p>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </th>
                  </tr>
                  <tr>
                    <th
                      v-if="loggedUser.papeis.filter(papel => papel.nome === 'PROCURADOR').length > 0"
                    >
                      <v-checkbox
                        :disabled="temPedidosParaProcurador || loadingRequests"
                        v-model="selecionado"
                        hide-details
                        @change="selecionarTodos()"
                      ></v-checkbox>
                    </th>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[header.sortable ? 'column sortable': '', 'text-xs-left', pagination.descending ? 'asc' : 'desc', headerRequestsTable.value === pagination.sortBy ? 'active' : '']"
                      @click="trocarOrdenamentoDaLista(header.value)"
                    >
                      <v-icon
                        small
                        color="black"
                        v-if="!pagination.descending && header.sortable == true"
                      >arrow_upward</v-icon>
                      <v-icon
                        small
                        color="black"
                        v-if="pagination.descending && header.sortable == true"
                      >arrow_downward</v-icon>
                      {{header.text}}
                    </th>
                  </tr>
                </template>
              </v-data-table>
              <div class="text-xs-center pt-2" v-if="quantidadeDeItens > 0">
                <v-pagination v-model="page" :length="pedidos.totalPages"></v-pagination>
              </div>
            </v-container>

            <v-dialog
              @keydown.esc="dialogExcluirItem = false"
              v-model="dialogExcluirItem"
              max-width="550px"
              color="error"
            >
              <v-card class="error darken-4" style="padding:20px">
                <v-card-title style="padding: 0px">
                  <p
                    class="messageSelectPaymentType"
                  >Tem certeza que deseja excluir esta solicitação?</p>
                </v-card-title>
                <v-card-text style="padding: 0px">
                  <v-layout row wrap>
                    <v-flex xs12 style="text-align:center">
                      <v-btn
                        ripple
                        style="font-weight: bold"
                        @click="deletarSolicitacao(idParaExcluir)"
                      >Sim</v-btn>
                      <v-btn ripple style="font-weight: bold" @click="dialogExcluirItem = false">Não</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-tab-item>

          <v-tab>Colaborador</v-tab>
          <v-tab-item :transition="false" :reverse-transition="false">
            <component-solicitacoes-reembolso
              ref="listaPedidos"
              :ehUsuarioAprovador="canFilterByPerson"
              :listarReembolsoDoUsuario="viewAtual"
            ></component-solicitacoes-reembolso>
          </v-tab-item>
        </v-tabs>
      </div>
    </template>
  </v-card>
</template>

<script>
import SolicitacoesReembolso from "@/components/solicitacao/ListaSolicitacoesColaboradores.vue";
import crudMixin from "@/mixins/crudMixin";

import { mapState } from "vuex";

import axios from "axios";

import get from "lodash.get";
import FiltroAvancado from "./FiltroAvancado.vue";
import { bus } from "../../main";
import moment from "moment";
import moedasMixins from "../../mixins/moedasMixin";

export default {
  mixins: [crudMixin],
  data() {
    return {
      dialogExcluirItem: false,
      idParaExcluir: null,
      dialogFormulario: true,
      items: [
        "Centro de Custo",
        "Conta Gerencial",
        "Solicitante",
        "Vencimento",
        "Valor do Pagamento",
        "Exceção",
      ],
      tab: true,
      selecionado: false,
      loadingStatus: false,
      modalFiltroStatus: null,
      modalFiltroDataInicio: false,
      modalFiltroDataFinal: false,
      filtro: {
        idDoUsuarioAprovador: "",
        papeis: [],
        idDoUsuarioRegistrador: "",
        status: "",
        nomeOuCpfOuCnpj: "",
        numeroDoDocumento: "",
        idDaEmpresa: "",
        idDoCentroDeCusto: "",
        idDaContaGerencial: "",
        solicitante: "",
        numeroDoPedido: "",
        formaDePagamento: "",
        dataEmissaoInicio: "",
        dataEmissaoFim: "",
        dataVencimentoInicio: "",
        dataVencimentoFim: "",
        valorInicio: "R$ 0,00",
        valorFinal: "R$ 0,00",
        pagamentoComExcecao: false,
      },
      page: 1,
      pagination:{
        sortBy: "empresa",
        descending: false,
        rowsPerPage: 100
      },
      viewAtual: {
        nome: "",
        botao: "",
      },
      paymentTypesDialog: false,
      pedidos: {
        content: [],
      },
      headerRequestsTable: [
        {
          text: "Fornecedor",
          value: "fornecedor.nome",
          sortable: true,
        },
        {
          text: "Empresa",
          value: "empresa",
          sortable: true,
        },
        {
          text: "Nº do Documento",
          value: "numeroDoDocumento",
          sortable: true,
        },
        {
          text: "Cadastro",
          value: "dataDeRegistro",
          sortable: true,
        },
        {
          text: "Vencimento",
          value: "dataDeVencimento",
          sortable: true,
        },
        {
          text: "Valor",
          value: "valorTotal",
          sortable: true,
        },
        {
          text: "Valor Liquido",
          value: "valorLiquido",
          sortable: true,
        },
        {
          text: "Tipo",
          value: "tipoDeSolicitacao",
          sortable: true,
        },
        {
          text: "Solicitante",
          value: "usuarioRegistrador.nome",
          sortable: true,
        },
        { text: "Status", value: "status", sortable: false, align: "center" },
        { text: "Ações", sortable: false, align: "center", width: "15%" },
      ],
      regraDataBusca: [(date) => !!date || "Data é obrigatória."],
      regraStatusBusca: [(status) => !!status || "Status é obrigatório."],
      totalLiquido: 0,
      totalBruto: 0,
    };
  },
  components: {
    componentSolicitacoesReembolso: SolicitacoesReembolso,
    componentFiltroAvancado: FiltroAvancado,
  },
  computed: {
    temPedidosParaProcurador() {
      if (this.pedidos.content == undefined) return true;
      let temPedidos =
        this.pedidos.content.filter(
          (i) => i.status == "ENVIADO_PARA_PROCURADOR"
        ).length > 0;
      if (temPedidos) return false;
      else return true;
    },
    ...mapState({
      loggedUser: (state) => state.loggedUser,
      myRequests: (state) => state.myRequests,
      loadingRequests: (state) => state.loadingRequests,
      users: (state) => state.users,
      loadingUsers: (state) => state.loadingUsers,
      listaDeStatus: (state) => state.listaDeStatus,
    }),
    quantidadeDeItens() {
      return get(this.pedidos, "totalElements", 0);
    },
    canFilterByPerson() {
      return (
        this.loggedUser.papeis.filter((papel) => {
          return (
            papel.nome === "APROVADOR" ||
            papel.nome === "APROVADOR_FINANCEIRO_EXCECAO" ||
            papel.nome === "APROVADOR_FINANCEIRO" ||
            papel.nome === "APROVADOR_CONTABILIDADE" ||
            papel.nome === "ADMIN_FORNECEDOR"
          );
        }).length > 0 || false
      );
    },
    nomeDoBotaoPelaViewAtual() {
      return this.viewAtual.nome === "Solicitações dos Usuários"
        ? "Ver minhas solicitações"
        : "Ver solicitações dos usuários";
    },
    itensSelecionados() {
      if (this.pedidos.content != undefined)
        return this.pedidos.content.filter((i) => i.selecionado == true).length;
      else return 0;
    },
  },
  watch: {
    "page"(pagina) {
      this.filtrarSolicitacoesDeFornecedor(pagina);
    },
    "pedidos.content"() {
      this.somarTotalLiquidoEBruto();
    },
  },
  mixins: [moedasMixins],
  methods: {
    pagamentoParcelado(pagamento){
      if(pagamento.ehParcelado) {
        return this.converteParaMoedaReal(pagamento.valorDaParcelaDoMes, pagamento.tipoDeMoeda)
      }
      return this.converteParaMoedaReal(pagamento.valorLiquido, pagamento.tipoDeMoeda)
    },
    async deletarSolicitacao(id) {
      this.dialogExcluirItem = false;
      await this.fazerRequest(`/solicitacoes/${id}`, "DELETE")
        .then(async (s) => {
          this.$store.commit("snackSucesso", "Pagamento excluído com sucesso.");
          await this.recarregarDados();
        })
        .catch((e) => this.$store.commit("snackErro", e))
        .finally((f) => (this.selecionado = false));
    },
    trocarOrdenamentoDaLista(coluna) {
      if (this.pagination.sortBy === coluna) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = coluna;
        this.pagination.descending = false;
      }
    },
    retornaStatus(statusRecebido) {
      let classe = "";
      let nome = "";
      this.listaDeStatus.map((i) => {
        if (i.valor == statusRecebido) {
          nome = i.nome;
          classe = i.classe;
        }
      });
      return `<p class="${classe} pt-2">${nome}</p>`;
    },
    async selecionarTodos() {
      let copiaPedidos = this.pedidos.content;
      for (let index = 0; index < copiaPedidos.length; index++) {
        const element = copiaPedidos[index];
        if (element.status == "ENVIADO_PARA_PROCURADOR")
          element.selecionado = this.selecionado;
      }
      this.pedidos.content = await copiaPedidos;
    },
    async aprovarPagamentos() {
      let itens = this.pedidos.content.filter((i) => i.selecionado == true);
      let apenasIds = itens.map((i) => i.id);
      this.$store.commit("snackLoading", "Aprovando pagamentos...");
      let objEnvio = {
        idDoAprovador: this.loggedUser.id,
        solicitacoes: apenasIds,
      };
      await this.fazerRequest("/solicitacoes", "PATCH", objEnvio)
        .then(async (s) => {
          this.$store.commit("snackSucesso", "Pagamentos aprovados");
        })
        .catch((e) =>
          this.$store.commit(
            "snackErro",
            "Houve um erro na aprovação dos pagamentos"
          )
        )
        .finally((f) => (this.selecionado = false));
    },
    formatarTipoDeSolicitacao(tipo) {
      let tipoFormatado = tipo;
      if (tipo)
        tipoFormatado =
          tipo.charAt(0).toUpperCase() + tipo.slice(1).toLowerCase();
      return tipoFormatado;
    },
    converteParaMoedaReal(numero, formatoDaMoeda) {
      let formatter;
      if (formatoDaMoeda == "USD")
        formatter = this.converterOutrasMoedas("en-US", "currency", "USD");
      else if (formatoDaMoeda == "AUD")
        formatter = this.converterOutrasMoedas("en-au", "currency", "AUD");
      else if (formatoDaMoeda == "CAD")
        formatter = this.converterOutrasMoedas("en-ca", "currency", "CAD");
      else if (formatoDaMoeda == "JPY")
        formatter = this.converterOutrasMoedas("ja", "currency", "JPY");
      else if (formatoDaMoeda == "EUR")
        formatter = this.converterOutrasMoedas("fr", "currency", "EUR");
      else if (formatoDaMoeda == "GBP")
        formatter = this.converterOutrasMoedas("en-gb", "currency", "GBP");
      else if (formatoDaMoeda == "SGD")
        formatter = this.converterOutrasMoedas("zh-sg", "currency", "SGD");
      else if (formatoDaMoeda == "MXN")
        formatter = this.converterOutrasMoedas("es-mx", "currency", "MXN");
      else formatter = this.converterOutrasMoedas("pt-BR", "currency", "BRL");
      return formatter.format(numero);
    },
    converterOutrasMoedas(linguagem, estilo, pais) {
      return new Intl.NumberFormat(linguagem, {
        style: estilo,
        currency: pais,
        minimumFractionDigits: 2,
      });
    },
    formataData(data) {
      let [ano, mes, dia] = data.split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    viewRequest(request) {
      const { id } = request;
      this.$router.push({ path: `/pagamentos/fornecedores/${id}` });
    },
    async mudaView() {
      if (this.viewAtual.nome === "Solicitações dos Usuários") {
        this.viewAtual.nome = "Minhas Solicitações";
        this.viewAtual.botao = "Ver solicitações dos usuários";

        this.recarregarDados();
      } else {
        this.viewAtual.nome = "Solicitações dos Usuários";
        this.viewAtual.botao = "Ver minhas solicitações";

        this.recarregarDados();
      }
    },
    recarregarDados() {
      bus.$emit("carregarDados", 1);
    },
    async fazerRequest(url, tipo, objeto) {
      this.$store.commit("set", {
        itemName: "loadingRequests",
        content: true,
      });

      let headers = {
        Authorization: `Bearer ${this.loggedUser.token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      let dataEnvio = "";

      if (tipo == undefined) tipo = "get";
      else {
        dataEnvio = JSON.stringify(objeto);
      }
      return await axios({
        method: tipo,
        url: `${url}`,
        responseType: "json",
        headers,
        data: dataEnvio,
      })
        .then(function (response) {
          response.data.content.map((p) => (p.selecionado = false));
          return response;
        })
        .catch((e) => {
          this.pedidos = { content: [] };
        })
        .finally((s) => {
          this.$store.commit("set", {
            itemName: "loadingRequests",
            content: false,
          });
        });
    },
    somarTotalLiquidoEBruto() {
      this.totalLiquido = 0.0;
      this.totalBruto = 0.0;
      let totalItens = 0;

      if (this.pedidos.content != undefined)
        totalItens = this.pedidos.content.length;

      for (let i = 0; i < totalItens; i++) {
        if (this.pedidos.content[i].tipoDeMoeda == "BRL") {
          if(this.pedidos.content[i].ehParcelado){
            this.totalLiquido += this.pedidos.content[i].valorDaParcelaDoMes;
          }else{
            this.totalLiquido += this.pedidos.content[i].valorLiquido;
          }
          this.totalBruto += this.pedidos.content[i].valorTotal;
        }
      }
    },
    async filtrarSolicitacoesDeFornecedor(pagina) {
      this.$store.commit("set", {
        itemName: "loadingRequests",
        content: true,
      });
      let urlFiltro = `/solicitacoes/busca?`;
      let filtroIdUsuarioRegistrador = "idDoUsuarioRegistrador=";
      let filtroIdUsuarioAprovador = "idDoUsuarioAprovador=";
      if (this.viewAtual.nome === "Minhas Solicitações") {
        filtroIdUsuarioRegistrador = `${filtroIdUsuarioRegistrador}${this.loggedUser.id}`;
        this.filtro.idDoUsuarioAprovador = null;
      } else
        filtroIdUsuarioAprovador = `${filtroIdUsuarioAprovador}${this.loggedUser.id}`;

      this.filtro.papeis = this.loggedUser.papeis;

      for (let i in this.filtro) {
        if (this.filtro[i] == undefined) {
          this.filtro[i] = "";
        }
      }

      let vencimentos = this.validarDatas(
        this.filtro.dataVencimentoInicio,
        this.filtro.dataVencimentoFim,
        "vencimento"
      );

      urlFiltro = `${urlFiltro}solicitante=${
        this.filtro.solicitante
      }&${filtroIdUsuarioRegistrador}&${filtroIdUsuarioAprovador}&dataEmissaoInicio=${
        this.filtro.dataEmissaoInicio
      }&dataEmissaoFim=${this.filtro.dataEmissaoFim}&dataVencimentoInicio=${
        this.filtro.dataVencimentoInicio
      }&dataVencimentoFim=${
        this.filtro.dataVencimentoFim
      }&nomeOuCpfOuCnpj=${this.filtro.nomeOuCpfOuCnpj
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "")}&numeroDoDocumento=${
        this.filtro.numeroDoDocumento
      }&numeroDoPedido=${this.filtro.numeroDoPedido}&status=${
        this.filtro.status
      }&empresa=${this.filtro.idDaEmpresa}&centroDeCusto=${
        this.filtro.idDoCentroDeCusto
      }&contaGerencial=${this.filtro.idDaContaGerencial}&formaDePagamento=${
        this.filtro.formaDePagamento
      }&valorInicio=${parseFloat(
        this.converterValorStringEmNumero(this.filtro.valorInicio, "BRL").trim()
      )}&valorFinal=${parseFloat(
        this.converterValorStringEmNumero(this.filtro.valorFinal, "BRL").trim()
      )}&pagamentoComExcecao=${this.filtro.pagamentoComExcecao}&pagina=${
        pagina - 1
      }`;
      
      localStorage.setItem(
        "camposSolicitacaoFornecedor",
        JSON.stringify(this.filtro)
      );
      await this.fazerRequest(urlFiltro)
        .then((resposta) => {
          resposta.data.content.map((s) => (s.selecionado = false));
          this.pedidos = resposta.data;
        })
        .catch((e) => {
          this.pedidos = [];
        });    
    },
    validarDatas(dataInicio, dataFim, tipo) {
      let dataParaTratar;
      let contaCorretaPorTipo = tipo == "vencimento" ? "somar" : "subtrair";

      if (dataInicio != "" && dataFim == "") {
        dataParaTratar = moment(dataInicio);

        dataFim = this.modificarMeses("somar", dataParaTratar);
      }

      if (dataInicio == "" && dataFim != "") {
        dataParaTratar = moment(dataFim);

        dataInicio = this.modificarMeses("subtrair", dataParaTratar);
      }

      if (dataInicio == "" && dataFim == "") {
        dataParaTratar = moment();

        if (tipo == "vencimento") {
          dataInicio = dataParaTratar.startOf("month").format("YYYY-MM-DD");
        } else {
          dataFim = dataParaTratar.endOf("month").format("YYYY-MM-DD");
        }

        if (tipo == "vencimento") {
          dataFim = this.modificarMeses(contaCorretaPorTipo, dataParaTratar);
          dataFim = moment(dataFim).startOf("month").format("YYYY-MM-DD");
        } else
          dataInicio = this.modificarMeses(contaCorretaPorTipo, dataParaTratar);
      }

      return [dataInicio, dataFim];
    },
    modificarMeses(tipoDeConta, dataRecebida) {
      dataRecebida = dataRecebida.clone();

      if (tipoDeConta == "somar") dataRecebida = dataRecebida.add(6, "months");
      else dataRecebida = dataRecebida.subtract(6, "months");

      return dataRecebida.format("YYYY-MM-DD");
    },
  },
  created() {
    if (
      this.loggedUser.papeis.filter((papel) => papel.nome !== "SOLICITANTE")
        .length > 0
    ) {
      this.viewAtual.nome = "Solicitações dos Usuários";
      this.viewAtual.botao = "Ver minhas solicitações";
    } else {
      this.viewAtual.nome = "Minhas Solicitações";
      this.viewAtual.botao = "Ver Solicitações dos usuários";
    }
    bus.$on("pedidosFiltrados", (pedidos) => {
      this.pedidos = pedidos;
    });
  },
};
</script>

<style scoped>
.soma-valores {
  font-weight: bold;
  color: #ff0d7b;
  width: 60% !important;
  font-size: 21px !important;
}

.checkbox-lista .v-input__slot {
  margin-bottom: 0px !important;
}

.checkbox-lista .v-messages.theme--light {
  display: none !important;
}

.messageSelectPaymentType {
  font-size: 20px;
  color: white;
  margin: auto;
  text-align: center;
}

.noDataSlot {
  font-size: 1em;
  padding: 10px;
}

.headerColor >>> thead {
  background: #cfd8dc;
}

.headerColor >>> th {
  color: #455a64 !important;
}

.headerColor >>> th i {
  color: #455a64 !important;
}
</style>
